module.exports = __webpack_public_path__ + "img/team2_3.6031afc7.jpg";